import { render, staticRenderFns } from "./PWMGUIIntroduce.vue?vue&type=template&id=0a4a382f&scoped=true&"
import script from "./PWMGUIIntroduce.vue?vue&type=script&lang=js&"
export * from "./PWMGUIIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./PWMGUIIntroduce.vue?vue&type=style&index=0&id=0a4a382f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a382f",
  null
  
)

component.options.__file = "PWMGUIIntroduce.vue"
export default component.exports